import { buttonModes, components, icons, popperPlacements, sizes } from '@/utils'

import button from '@/components/button'
import tag from '@/components/tag'

function renderActivator(h) {
  return h(
    button,
    {
      props: {
        icon: icons.filter_list,
        mode: buttonModes.flat,
        color: this.activatorColor,
        tooltip: this.getTranslate('commons.titles.filter')
      },
      slot: 'activator'
    }
  )
}

function renderTitle(h) {
  return h(
    tag,
    {
      props: {
        label: this.getTranslate('commons.titles.filter'),
        as: 'button',
        size: sizes.tiny
      }
    }
  )
}
function renderResetButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.reset'),
        mode: buttonModes.flat,
        size: sizes.tiny,
        disabled: this.isDefault
      },
      on: {
        click: () => {
          this.reset()
        }
      }
    }
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: 'button-filter__header'
    },
    [
      renderTitle.call(this, h),
      renderResetButton.call(this, h)
    ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: 'button-filter__content'
    },
    [
      renderHeader.call(this, h),
      this.$slots.default
    ]
  )
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        closeOnContentClick: false,
        placement: popperPlacements['bottom-start'],
        offsetDistance: 8
      }
    },
    [
      renderActivator.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
